import { render, staticRenderFns } from "./QuadratureQuery.vue?vue&type=template&id=559f742e&"
import script from "./QuadratureQuery.vue?vue&type=script&lang=js&"
export * from "./QuadratureQuery.vue?vue&type=script&lang=js&"
import style0 from "./QuadratureQuery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports